import Vue from 'vue';
import {Mixin} from 'vue-mixin-decorator';
import {getSizeRatio} from '@/script/common';

// @ts-ignore
@Mixin
export default class PageVue extends Vue {
  protected sizeRatio: number = 1;
  protected fontSize: number = 18;

  private created() {
    window.addEventListener('resize', this.onResize);
    this.onResize();
  }

  private onResize() {
    // フレームのサイズを調整
    const frameWidth = 1000;
    this.sizeRatio = getSizeRatio(frameWidth);
    this.fontSize = Math.max(10, 18 * this.sizeRatio);
  }
}
